import { RiLockLine } from "@remixicon/react";
import { cn } from "cn";
import type { ComponentProps } from "react";

interface LockedBannerProps extends ComponentProps<"div"> {
  /** Что закрыто: «Звук и уведомления». */
  label: string;
  /** Пояснение, чем открывается. */
  text: string;
}

/** Полоса над экраном, который остаётся виден: что закрыто и чем открывается. */
function LockedBanner({ label, text, className, ...props }: LockedBannerProps) {
  return (
    <div
      data-slot="locked-banner"
      role="status"
      className={cn(
        "flex items-center gap-2 border-b border-border px-3 py-2 text-sm text-muted-foreground",
        className,
      )}
      {...props}
    >
      <RiLockLine aria-hidden="true" className="size-4 shrink-0" />
      <span>
        {label}: {text}
      </span>
    </div>
  );
}

export { LockedBanner };
